import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { GenericService } from 'src/app/services/generic.service';

@Component({
  selector: 'app-tobe-verified-list',
  templateUrl: './tobe-verified-list.component.html',
  styleUrls: ['./tobe-verified-list.component.css']
})
export class TobeVerifiedListComponent implements OnInit {

  form: any | FormGroup
  modelSubtitle = false
  checked = false
  name = ""
  version = ""
  isActive = false
  data: any =[];
  ECdata: any = [];
  page: number = 1;
  count: number = 0;
  tableSize: number = 10;
  first: any = 0
  tableSizes: any = [3, 6, 9, 12];
  cid:any
  isLoading: any = false
  imageUrl:any = ""


actionControls: any = {
  isAdd: false, 
  isView: false, 
  isDelete: false, 
  isModify: false 
}
  constructor(private fb: FormBuilder,private toastr: ToastrService,private generic_service: GenericService) { }

  ngOnInit(): void {

  let href:any = window.location.href;
  let messages = href.split('/') 
  let action: any = this.generic_service.checkActionControls(messages[messages.length-1])
  this.actionControls = action
    this.cid = sessionStorage.getItem('cid')
    this.getAllECVerified();
    this.form = this.fb.group({
      existingCustomerInfoId: [''],
    })  
  }

  cancelModel(){
    document.getElementById("closeModalButton")?.click()
    document.getElementById("closeModalButton1")?.click()
    document.getElementById("closeModalButton3")?.click()
  }

  onTableDataChange(event: any) {
    this.page = event;
    this.getAllECVerified();
  }
  onTableSizeChange(event: any): void {
    this.tableSize = event.target.value;
    this.page = 1;
    this.getAllECVerified();
  }

  getAllECVerified(){
    this.isLoading = true

    this.generic_service.getExistingCustomerByStatus('VERIFIED').subscribe(
      (response:any)=>{
        this.ECdata = response.response;
        this.count = response.response.length;
        this.isLoading = false

        console.log(response)
      }
    )
  }

  getECbyId(id:any){
    this.generic_service.getExistingCustomerById(id).subscribe(
      (res:any)=>{
        this.data = [];
        console.log(res);
        this.data.push(res.response);

        // this.form.setValue(
        //   {
        //     existingCustomerInfoId: res.response.existingCustomerInfoId,
        //     userId: ['']
        //   }
        // );
      }
    )
  }

  approveEC(){
    let body = {
      "customerId": this.data[0].existingCustomerInfoId,
      "cid": this.data[0].cid,
      "existingCustomerInfoStatus": {
        "note": "",
        "status": "APPROVED",
        "updatedDate": 0
      }
    }
    console.log(body)

    this.generic_service.updateExistingCustomerInfoStatus(body).subscribe(
      (res:any)=>{
        document.getElementById("closeModalButton")?.click()
        this.getAllECVerified()
      }
    )
  }

  rejectEC(){
    let body = {
      "customerId": this.data[0].existingCustomerInfoId,
      "cid": this.data[0].cid,
      "existingCustomerInfoStatus": {
        "note": "",
        "status": "REJECTED",
        "updatedDate": 0
      }
    }

    this.generic_service.updateExistingCustomerInfoStatus(body).subscribe(
      (res:any)=>{
        document.getElementById("closeModalButton")?.click()
        this.getAllECVerified()
      }
    )
  }

  imageUrlSelect(url:any){
    this.imageUrl = url
  }

  closeImage(){
    this.imageUrl = ""
  }

}

